"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetQueryDataByFieldName = void 0;
const client_1 = require("@apollo/client");
// A hook that subscribes to a query with useQuery and gets the data under a particular field name
// of the raw useQuery response as the new data response.
const useGetQueryDataByFieldName = (query, fieldName, options) => {
    var _a, _b;
    const result = (0, client_1.useQuery)(query, {
        fetchPolicy: 'cache-only',
        returnPartialData: options === null || options === void 0 ? void 0 : options.returnPartialData,
    });
    return {
        data: (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a[fieldName]) !== null && _b !== void 0 ? _b : null,
    };
};
exports.useGetQueryDataByFieldName = useGetQueryDataByFieldName;
//# sourceMappingURL=useGetQueryDataByFieldName.js.map